import { useSaveMgFilters as globalUseSaveMgFilters } from '@coverright/data-access/medigap';
import { useMedicareQuote } from '../medicare/use-medicare-quote';
import { useMedigapQuote } from './use-medigap-quote';
import { useUserProfile } from '../enrollment/use-user-profile';

export function useSaveMgFilters() {
  const quote = useMedigapQuote();
  const medicareQuote = useMedicareQuote();
  const profile = useUserProfile();
  return globalUseSaveMgFilters(quote!, {
    zip: medicareQuote?.zip || profile?.zip,
    tobacco: profile?.tobacco,
    gender: profile?.gender,
    age: profile?.age,
  }, 400);
}
